<template>
  <v-container>
    <v-row class="mx-10 mb-5" align="center">
      <h3>会話デッキを作る</h3>
      <v-spacer></v-spacer>

      <v-btn color="primary" @click="save()" :disabled="!valid">
        <v-icon left>mdi-content-save-move</v-icon>この内容で会話デッキを作成
      </v-btn>
    </v-row>
    <v-row class="mx-10">
      <DeckForm :deck="deck" @form-change="onFormChange()" ref="deckForm" />
    </v-row>

    <v-row class="mx-10 mb-5" align="center">
      <h3>会話カード</h3>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click.stop="openAddCardDialog()">
        <v-icon left>mdi-plus</v-icon>会話カードを追加
      </v-btn>

      <v-dialog v-model="cardDialog" max-width="720">
        <v-card>
          <v-card-title class="headline">会話カードの作成</v-card-title>

          <CardForm :card="editingCard" />

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="secondary darken-1" text @click="cardDialog = false">キャンセル</v-btn>

            <v-btn
              color="primary darken-1"
              text
              @click="addCard()"
              :disabled="!editingCard || !editingCard.title.length"
            >作成</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <CardList
        :cards="cards"
        @select-card="openAddCardDialog($event)"
        :itemEditable="true"
        @select-delete="removeCard($event)"
      />
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="420">
      <v-card>
        <v-card-title class="headline">会話デッキの復元</v-card-title>
        <v-card-text>編集途中の会話デッキが見つかりました</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-4" outlined text @click="dialog = false; reset();">破棄して新しく作り直す</v-btn>
          <v-btn color="green darken-1" outlined text @click="dialog = false; restore();">復元</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import DeckForm from "@/components/DeckForm.vue";
import CardList from "@/components/CardList.vue";
import CardForm from "@/components/CardForm.vue";
import { KaiwaCard, initialCard } from "@/models/KaiwaCard";

import { mapGetters } from "vuex";

export default {
  name: "CreateDeck",
  components: {
    DeckForm,
    CardList,
    CardForm,
  },
  computed: {
    ...mapGetters("draftDeck", {
      loading: "loading",
      deck: "getDraftDeck",
      cards: "getDraftCards",
      hasDraft: "hasDraft",
    }),
  },
  data: () => ({
    dialog: false,
    cardDialog: false,
    valid: false,
    editingCard: KaiwaCard,
    mode: "edit" | "add",
    editingIndex: -1,
  }),
  created() {
    this.dialog = this.hasDraft;
  },
  methods: {
    onFormChange() {
      if (this.deck.title && this.deck.title.length && this.cards.length) {
        this.valid = true;
      } else {
        this.valid = false;
      }

      this.$store.dispatch("draftDeck/updateDraftDeck", {
        deck: this.deck,
        cards: this.cards,
      });
    },
    reset() {
      this.$store.dispatch("draftDeck/resetDraftDeck");
    },
    restore() {
      this.$store.dispatch("draftDeck/restoreDraftDeck");
    },
    save() {
      this.$store.dispatch("draftDeck/createDeck");
    },
    openAddCardDialog(toEditCard) {
      this.cardDialog = true;
      this.editingCard = toEditCard
        ? JSON.parse(JSON.stringify(toEditCard))
        : JSON.parse(JSON.stringify(initialCard));
      this.mode = toEditCard ? "edit" : "add";
      if (this.mode === "edit") {
        this.editingIndex = this.cards.indexOf(toEditCard);
      }
    },
    addCard() {
      this.cardDialog = false;

      if (this.mode === "edit") {
        this.$store.dispatch("draftDeck/updateDraftDeck", {
          deck: this.deck,
          cards: [
            this.editingCard,
            ...this.cards.filter((v, i) => i !== this.editingIndex),
          ],
        });
      } else {
        this.$store.dispatch("draftDeck/updateDraftDeck", {
          deck: this.deck,
          cards: [this.editingCard, ...this.cards],
        });
      }
    },
    removeCard(card) {
      this.$store.dispatch("draftDeck/updateDraftDeck", {
        deck: this.deck,
        cards: [...this.cards.filter((v) => v !== card)],
      });
    },
  },
};
</script>
